import React from "react";
import Herosection from "../components/landingpage/Herosection";
import Ourcommitment from "../components/landingpage/Ourcommitment";
import Aboutus from "../components/landingpage/Aboutus";
import Testimonialnew from "../components/landingpage/Testimonial";
import InfographicCard from "../components/InforGraphic/infogrphicCard";
import { PartnersLight } from "../components/landingpage/Partners";
import CtaBanner from "../components/CtaBanner";
import { captureEvent } from "../api/posthog";

const Landingpage = () => {
  const handleDownload = () => {
    captureEvent("signup_started", { source: "landing_page_join_village" });
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent) || /Windows/i.test(userAgent)) {
      window.plausible("Play Store Click");
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile";
    } else if (/iPad|iPhone|iPod|ios/.test(userAgent) && !window.MSStream) {
      window.plausible("App Store Click");
      window.location.href =
        "https://apps.apple.com/us/app/social-spectrum/id6473112455";
    } else {
      window.plausible("Play Store Click");
      window.open(
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile",
        "_blank"
      );
    }
  };

  return (
    <div className="w-full flex flex-col items-stretch">
      <Herosection />
      <Ourcommitment />
      <Aboutus />
      <InfographicCard />
      <PartnersLight />
      <Testimonialnew />
      {/* Single Spectrum Blue CTA before footer — no second full-blue partners band */}
      <CtaBanner
        title="Join Your Village."
        description="Join thousands of parents building stronger tomorrows for their neurodivergent children."
        onDownload={handleDownload}
        buttonLabel="Download Now →"
      />
    </div>
  );
};

export default Landingpage;
